class EagerLoader {
    constructor() {
        this.targets = $('img[data-src]')
        this.urls = [];
        this.targets.each(function(id, target){
            var $target = $(target);
            this.urls.push($target.data('src'));
        }.bind(this))
    }
    convert() {
        $('img[data-src]').each(function(id, target){
            var $target = $(target);
            var src = $target.data('src');
            $target.attr({
                src: src,
            });
            $target.removeAttr('data-src');
        });
    }
}

export default EagerLoader



/** WEBPACK FOOTER **
 ** ./src/intro/eager_loader.js
 **/